import { renderApp } from '@/main';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

renderApp(rootElement);
